import { Card, CardContent, Typography, Grid, TextField, Button } from '@mui/material';
import { ChangeEventHandler, Dispatch, FC, SetStateAction, useState } from 'react';
import { useTranslation } from 'react-i18next';
import IResponse from '../../interfaces/response';
import { IUser } from '../../interfaces/user';
import axios from 'axios';

interface Props {
	setFetchedData: Dispatch<SetStateAction<IUser[]>>;
}

const FilterTableList: FC<Props> = ({ setFetchedData }) => {
	const [name, setName] = useState('');
	const [lastName, setLastName] = useState('');
	const [email, setEmail] = useState('');
	const { t } = useTranslation();

	const handleChangeName: ChangeEventHandler<HTMLInputElement> = e => {
		setName(e.target.value);
	};

	const handleChangeLastName: ChangeEventHandler<HTMLInputElement> = e => {
		setLastName(e.target.value);
	};

	const handleChangeEmail: ChangeEventHandler<HTMLInputElement> = e => {
		setEmail(e.target.value);
	};

	const handleSearchUsers = () => {
		axios<IResponse<any>>({
			url: `/admin/users`,
			params: {
				search: JSON.stringify([
					{
						field: 'first_name',
						value: name,
					},
					{
						field: 'last_name',
						value: lastName,
					},
					{
						field: 'email',
						value: email,
					},
				]),
			},
		}).then(res => {
			if (res.data.success) {
				setFetchedData(res.data.data);
			}
		});
	};

	return (
		<Card className="my-3 p-3">
			<CardContent>
				<Typography className="mb-4 text-lg">{t('filter')}</Typography>
				<Grid container>
					<Grid xs={6} md={4}>
						<TextField className="w-11/12" onChange={handleChangeName} fullWidth label={t('name')} />
					</Grid>
					<Grid xs={6} md={4}>
						<TextField className="w-11/12" onChange={handleChangeLastName} fullWidth label={t('last_name')} />
					</Grid>
					<Grid xs={6} md={4}>
						<TextField className="w-11/12" onChange={handleChangeEmail} fullWidth label={t('email')} />
					</Grid>
					<Grid xs={6} md={4}>
						<TextField className="mt-4 w-11/12" fullWidth label={t('access_level')} />
					</Grid>
				</Grid>
			</CardContent>
			<div className="flex justify-end">
				<Button onClick={() => handleSearchUsers()} className="px-7 py-2">
					{t('search')}
				</Button>
			</div>
		</Card>
	);
};

export default FilterTableList;
